import { useState, useEffect } from "react";
import { Form, Button, Col, Row } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import * as XLSX from "xlsx";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faUpload,
  faDownload,
  faXmark,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { APIUS } from "../../../../../../config/apius";
import { APIMS } from "../../../../../../config/apims";
import LoaderAction from "../../../../../Loader/LoaderHome";
import "bulma/css/bulma.css";
import "../../../../../../index.css";

// 90 kolom header sesuai tabel ysb_students (tanpa kolom filter, relasi khusus, status, dan sistem)
export const STUDENT_COLUMNS = [
  "nama_lengkap",
  "nisn",
  "nis_ypi",
  "kode_absen",
  "order_absen",
  "tahun_ajaran",
  "tahun_ajaran_pindahan",
  "file_akte_kelahiran",
  "file_kartu_keluarga",
  "file_ktp_orang_tua",
  "file_raport",
  "file_surat_keterangan_asal_sekolah",
  "nama_alias",
  "jenis_kelamin",
  "no_portal",
  "nik",
  "no_kk",
  "tempat_lahir",
  "tanggal_lahir_siswa",
  "agama",
  "kewarnegaraan",
  "anak_ke",
  "jumlah_saudara_kandung",
  "bahasa_dirumah",
  "email_murid",
  "email_siswa",
  "alamat_lengkap",
  "provinsi",
  "kota_kabupaten",
  "kecamatan",
  "kelurahan",
  "kode_pos",
  "warga_summarecon",
  "jarak_rumah_sekolah",
  "waktu_tempuh_sekolah",
  "ke_sekolah_dengan",
  "penyakit_diderita",
  "kelainan_jasmani",
  "pernah_dirawat_di",
  "tinggi",
  "berat",
  "linkar_kepala",
  "ukuran_sepatu",
  "sekolah_asal",
  "provinsi_asal",
  "kota_kabupaten_asal",
  "kecamatan_asal",
  "kelurahan_desa_asal",
  "kode_pos_asal",
  "nama_sekolah_asal",
  "akreditasi_sekolah_asal",
  "pindahan_dari_sekolah",
  "syarat_1",
  "syarat_2",
  "syarat_3",
  "syarat_4",
  "nama_lengkap_ayah",
  "nik_ayah",
  "tempat_lahir_ayah",
  "tanggal_lahir_ayah",
  "kewarganegaraan_ayah",
  "pendidikan_terakhir_ayah",
  "pekerjaan_ayah",
  "penghasilan_ayah",
  "no_handphone_ayah",
  "alamat_email_ayah",
  "keterangan_ayah",
  "nama_lengkap_ibu",
  "nik_ibu",
  "tempat_lahir_ibu",
  "tanggal_lahir_ibu",
  "kewarnegaraan_ibu",
  "pekerjaan_ibu",
  "penghasilan_ibu",
  "no_handphone_ibu",
  "alamat_email_ibu",
  "keterangan_ibu",
  "bidang_akademik",
  "kesenian",
  "pendidikan_jasmani",
  "lain_lain",
  "saudara_kandung_di_sekolah",
  "internet",
  "billboard",
  "teman",
  "pameran",
  "rekomendasi_asal_sekolah",
  "spanduk",
  "keluarga",
];

export const downloadStudentTemplate = () => {
  const sampleRow = {
    nama_lengkap: "Ahmad Fulan",
    nisn: "0012345678",
    nis_ypi: "4408-2425001",
    kode_absen: "01",
    order_absen: "1",
    tahun_ajaran: "2026/2027",
    tahun_ajaran_pindahan: "",
    file_akte_kelahiran: "",
    file_kartu_keluarga: "",
    file_ktp_orang_tua: "",
    file_raport: "",
    file_surat_keterangan_asal_sekolah: "",
    nama_alias: "Ahmad",
    jenis_kelamin: "Laki-laki",
    no_portal: "",
    nik: "3275000000000001",
    no_kk: "3275000000000002",
    tempat_lahir: "Bekasi",
    tanggal_lahir_siswa: "2015-05-12",
    agama: "Islam",
    kewarnegaraan: "WNI",
    anak_ke: "1",
    jumlah_saudara_kandung: "2",
    bahasa_dirumah: "Indonesia",
    email_murid: "ahmad@example.com",
    email_siswa: "ahmad.siswa@example.com",
    alamat_lengkap: "Jl. Boulevard No. 1",
    provinsi: "Jawa Barat",
    kota_kabupaten: "Kota Bekasi",
    kecamatan: "Medan Satria",
    kelurahan: "Pejuang",
    kode_pos: "17131",
    warga_summarecon: "1",
    jarak_rumah_sekolah: "2 km",
    waktu_tempuh_sekolah: "15 menit",
    ke_sekolah_dengan: "Kendaraan Pribadi",
    penyakit_diderita: "-",
    kelainan_jasmani: "-",
    pernah_dirawat_di: "-",
    tinggi: "135",
    berat: "32",
    linkar_kepala: "52",
    ukuran_sepatu: "35",
    sekolah_asal: "TK Islam Al Azhar",
    provinsi_asal: "Jawa Barat",
    kota_kabupaten_asal: "Kota Bekasi",
    kecamatan_asal: "Medan Satria",
    kelurahan_desa_asal: "Pejuang",
    kode_pos_asal: "17131",
    nama_sekolah_asal: "TK Islam Al Azhar",
    akreditasi_sekolah_asal: "A",
    pindahan_dari_sekolah: "",
    syarat_1: "1",
    syarat_2: "1",
    syarat_3: "1",
    syarat_4: "1",
    nama_lengkap_ayah: "Fulan Senior",
    nik_ayah: "3275000000000003",
    tempat_lahir_ayah: "Jakarta",
    tanggal_lahir_ayah: "1980-01-01",
    kewarganegaraan_ayah: "WNI",
    pendidikan_terakhir_ayah: "S1",
    pekerjaan_ayah: "Karyawan Swasta",
    penghasilan_ayah: "> 10.000.000",
    no_handphone_ayah: "081234567890",
    alamat_email_ayah: "ayah@example.com",
    keterangan_ayah: "Ayah Kandung",
    nama_lengkap_ibu: "Fulanah",
    nik_ibu: "3275000000000004",
    tempat_lahir_ibu: "Bandung",
    tanggal_lahir_ibu: "1983-05-10",
    kewarnegaraan_ibu: "WNI",
    pekerjaan_ibu: "Ibu Rumah Tangga",
    penghasilan_ibu: "-",
    no_handphone_ibu: "081234567891",
    alamat_email_ibu: "ibu@example.com",
    keterangan_ibu: "Ibu Kandung",
    bidang_akademik: "Matematika",
    kesenian: "Menggambar",
    pendidikan_jasmani: "Berenang",
    lain_lain: "-",
    saudara_kandung_di_sekolah: "-",
    internet: "1",
    billboard: "1",
    teman: "1",
    pameran: "1",
    rekomendasi_asal_sekolah: "1",
    spanduk: "1",
    keluarga: "1",
  };

  const ws = XLSX.utils.json_to_sheet([sampleRow], { header: STUDENT_COLUMNS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template Siswa");
  XLSX.writeFile(wb, "template_import_siswa.xlsx");
};

export default function ModalImport(props) {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");

  // Options for filters
  const [branches, setBranches] = useState([]);
  const [schools, setSchools] = useState([]);
  const [semesters, setSemesters] = useState([]);

  const [form, setForm] = useState({
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_academic_year_id: "",
    ysb_semester_id: "",
  });

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    const loadInitialFilters = async () => {
      try {
        const [resBranches, resSemesters] = await Promise.all([
          APIMS.get("/api/branches?page=0&limit=100&ascending=0&search=", fetchParams).catch(() => null),
          APIMS.get("/api/semesters?page=1&limit=1000&ascending=1&search=", fetchParams).catch(() => null),
        ]);

        if (resBranches?.data?.data) {
          setBranches(resBranches.data.data);
        }
        if (resSemesters?.data?.data) {
          const semesterList = resSemesters.data.data;
          setSemesters(semesterList);

          // Default ke semester yang aktif jika ada
          const active = semesterList.find((s) => Number(s?.status) === 1);
          if (active) {
            setForm((prev) => ({
              ...prev,
              ysb_semester_id: active.id,
              ysb_academic_year_id: active.ysb_academic_year_id || "",
            }));
          }
        }
      } catch (e) {
        console.error("Gagal memuat opsi filter:", e);
      }
    };

    loadInitialFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBranchChange = async (branchId) => {
    setForm((prev) => ({
      ...prev,
      ysb_branch_id: branchId,
      ysb_school_id: "",
    }));
    setSchools([]);

    if (!branchId) return;

    try {
      const res = await APIMS.get(
        `/api/schools?page=0&limit=100&ascending=0&search=&ascending_name=true&branch=${branchId}`,
        fetchParams
      );
      if (res?.data?.data) {
        setSchools(res.data.data);
      }
    } catch (e) {
      setSchools([]);
    }
  };

  const handleSemesterChange = (semesterId) => {
    const selected = semesters.find((s) => String(s?.id) === String(semesterId));
    setForm((prev) => ({
      ...prev,
      ysb_semester_id: semesterId,
      ysb_academic_year_id: selected?.ysb_academic_year_id || "",
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const binaryStr = evt.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        if (!jsonData || jsonData.length === 0) {
          swal({
            title: "Peringatan",
            text: "File Excel kosong atau tidak memiliki baris data!",
            icon: "warning",
            timer: 3000,
            buttons: false,
          });
          setExcelData([]);
          return;
        }

        setExcelData(jsonData);
      } catch (err) {
        swal({
          title: "Error",
          text: "Gagal membaca berkas Excel. Pastikan format file benar (.xlsx atau .xls).",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
        setExcelData([]);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!excelData || excelData.length === 0) {
      swal({
        title: "Peringatan",
        text: "Silakan pilih berkas Excel yang valid terlebih dahulu!",
        icon: "warning",
        timer: 3000,
        buttons: false,
      });
      return;
    }

    setLoading(true);
    try {
      const normalizedStudents = excelData.map((s) => {
        const item = { ...s };
        if (item.warga_summarecon !== undefined && item.warga_summarecon !== null && item.warga_summarecon !== "") {
          const wsStr = String(item.warga_summarecon).trim().toLowerCase();
          if (["ya", "yes", "true", "1"].includes(wsStr)) {
            item.warga_summarecon = 1;
          } else if (["tidak", "no", "false", "0"].includes(wsStr)) {
            item.warga_summarecon = 0;
          }
        }
        return item;
      });

      const payload = {
        students: normalizedStudents,
        ysb_branch_id: form.ysb_branch_id || null,
        ysb_school_id: form.ysb_school_id || null,
        ysb_academic_year_id: form.ysb_academic_year_id || null,
        ysb_semester_id: form.ysb_semester_id || null,
      };

      const response = await APIUS.post("/api/students/upload", payload, fetchParams);

      if (response?.status === 200) {
        swal({
          title: "Berhasil",
          text: `Berhasil mengimpor ${response.data.total || excelData.length} data siswa!`,
          icon: "success",
          timer: 3000,
          buttons: false,
        });

        if (props.GetResponseData) {
          props.GetResponseData();
        }
        props.onHide();
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Terjadi kesalahan saat mengunggah data siswa.",
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal">
      {loading && <LoaderAction />}

      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom"
          style={{ backgroundColor: "#ffffff" }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                backgroundColor: "#e8f0fe",
                color: "#1a73e8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "12px",
              }}
            >
              <FontAwesomeIcon icon={faUpload} size="lg" />
            </div>
            <div>
              <h5 className="modal-title font-weight-bold mb-0 text-dark" style={{ fontSize: "18px" }}>
                Import Data Siswa
              </h5>
              <small className="text-muted" style={{ fontSize: "12px" }}>
                Unggah data siswa secara massal menggunakan berkas Excel
              </small>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-light rounded-circle p-2"
            onClick={props.onHide}
            style={{ width: "36px", height: "36px", border: "1px solid #e0e0e0" }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div
            style={{
              background: "#f0f9ff",
              border: "1px solid #bae6fd",
              borderRadius: "8px",
              padding: "14px 16px",
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <div style={{ fontWeight: "600", color: "#0369a1", fontSize: "14px" }}>
                Template Excel Siswa
              </div>
              <div style={{ color: "#0c4a6e", fontSize: "12px", marginTop: "2px" }}>
                Unduh template dengan struktur kolom yang sesuai untuk mengisi data siswa.
              </div>
            </div>
            <button
              type="button"
              onClick={downloadStudentTemplate}
              className="btn btn-sm btn-outline-primary"
              style={{ fontWeight: "600", display: "inline-flex", alignItems: "center", gap: "6px" }}
            >
              <FontAwesomeIcon icon={faDownload} /> Download Template
            </button>
          </div>

          <Form onSubmit={handleSubmit}>
            <div style={{ fontWeight: "600", marginBottom: "12px", fontSize: "14px", color: "#333" }}>
              Filter Penugasan (Opsional)
            </div>

            <Row>
              <Col md="4">
                <div className="mb-3">
                  <label className="label-name-form" style={{ fontWeight: "500", fontSize: "13px" }}>
                    Cabang
                  </label>
                  <select
                    className="form-select"
                    style={{ fontSize: "13px", height: "38px" }}
                    value={form.ysb_branch_id}
                    onChange={(e) => handleBranchChange(e.target.value)}
                  >
                    <option value="">-- Pilih Cabang --</option>
                    {branches.map((b) => (
                      <option key={b.branch_code || b.id} value={b.branch_code || b.id}>
                        {b.name || b.nama_cabang || b.branch_name}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>

              <Col md="4">
                <div className="mb-3">
                  <label className="label-name-form" style={{ fontWeight: "500", fontSize: "13px" }}>
                    Sekolah
                  </label>
                  <select
                    className="form-select"
                    style={{ fontSize: "13px", height: "38px" }}
                    value={form.ysb_school_id}
                    onChange={(e) => setForm((prev) => ({ ...prev, ysb_school_id: e.target.value }))}
                    disabled={!form.ysb_branch_id}
                  >
                    <option value="">-- Pilih Sekolah --</option>
                    {schools.map((s) => (
                      <option key={s.id || s.school_code} value={s.id || s.school_code}>
                        {s.name || s.nama_sekolah || s.school_name}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>

              <Col md="4">
                <div className="mb-3">
                  <label className="label-name-form" style={{ fontWeight: "500", fontSize: "13px" }}>
                    Semester
                  </label>
                  <select
                    className="form-select"
                    style={{ fontSize: "13px", height: "38px" }}
                    name="ysb_semester_id"
                    value={form.ysb_semester_id}
                    onChange={(e) => handleSemesterChange(e.target.value)}
                  >
                    <option value="">-- Pilih Semester --</option>
                    {semesters.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_year} (Semester {user?.semester}){Number(user?.status) === 1 ? " • Aktif" : ""}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>

            <hr style={{ margin: "10px 0 20px 0" }} />

            <div style={{ fontWeight: "600", marginBottom: "10px", fontSize: "14px", color: "#333" }}>
              Pilih Berkas Excel
            </div>

            <div className="mb-3">
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                className="form-control"
                style={{ padding: "8px", fontSize: "13px" }}
                required
              />
            </div>

            {fileName && (
              <div
                style={{
                  background: "#f8f9fa",
                  border: "1px dashed #ced4da",
                  borderRadius: "6px",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "13px",
                }}
              >
                <FontAwesomeIcon icon={faFileExcel} style={{ color: "#28a745", fontSize: "20px" }} />
                <div>
                  <strong>{fileName}</strong>
                  <div style={{ color: "#6c757d", fontSize: "12px" }}>
                    <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#28a745" }} /> Terbaca:{" "}
                    <strong>{excelData.length}</strong> baris data siswa
                  </div>
                </div>
              </div>
            )}

            <div className="d-flex mt-4" style={{ alignItems: "center" }}>
              <Button
                type="button"
                color="secondary"
                onClick={props.onHide}
                style={{ minWidth: "100px" }}
              >
                Batal
              </Button>
              <Button
                type="submit"
                color="primary"
                className="ml-auto"
                disabled={loading || excelData.length === 0}
                style={{ minWidth: "140px" }}
              >
                <FontAwesomeIcon icon={faUpload} className="mr-1" /> Simpan / Import
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
